//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Slider from '@/components/common/Slider'
import ElLottie from '@/components/UI/el-lottie'
import HowVideoSlide from '@/components/redesign/HowVideoSlide'
import YoutubeIframe from '@/components/UI/YoutubeIframe'
import { mapState } from 'vuex'

import { DESKTOP_MIN_WIDTH } from '@/const/breakpoints'

const { LANDING_NEW_SLIDER } = require('@/const/featureConstants')
const { mapGetters } = require('vuex')

export default {
  name: 'HowSection',
  components: {
    Slider,
    ElLottie,
    HowVideoSlide,
    YoutubeIframe,
  },
  data() {
    return {
      DESKTOP_MIN_WIDTH,
      sliderProjectsStatus: [],
      isMobile: null,
      currentSlide: 0,
      isFirstSliderInit: true,
      isVideoActive: false,
      sliderOptions: {
        slidesPerView: 3,
        loop: true,
        spacing: 0,
        centered: true,
        mode: 'snap',
        breakpoints: {
          '(max-width: 640px)': {
            slidesPerView: 1,
            centered: false,
          },
        },
      },
      howAnimationFirst: {
        container: '.how__img',
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: `/${this.$route.path.split('/').pop()}/how-1.json`,
      },
      howAnimationSecond: {
        container: '.how__slider-img',
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: `/${this.$route.path.split('/').pop()}/how-2.json`,
      },
    }
  },
  computed: {
    ...mapState(['i18n']),
    ...mapGetters({
      featureEnabled: 'landings/featureEnabled',
    }),
    isNewSlider() {
      return this.featureEnabled(LANDING_NEW_SLIDER)
    },
    isSnakeAllowed() {
      return this.i18n.locale === 'ru'
    },
    isCamp() {
      return this.$route.path.includes('/camp')
    },
    isFrontend() {
      return this.$route.path.split('/').pop() === 'frontend'
    },
    initialSlidesCount() {
      if (this.isNewSlider) {
        const accordion = [...this.$getBullets('accordion')]
        return accordion.length
      }

      const slides = [...this.$getBullets('approachScreenPicture')]
      return slides.length
    },
    slides() {
      let slides = []

      if (this.isNewSlider) {
        slides = []
        const accordion = [...this.$getBullets('accordion')]
        if (accordion.length > 0) {
          for (const i in accordion) {
            slides.push({
              name: accordion[i].name,
              text: accordion[i].text,
              url:
                accordion[i].imageFile !== undefined &&
                accordion[i].imageFile.url !== undefined
                  ? accordion[i].imageFile.url
                  : '',
            })
          }
        }
      } else {
        slides = [...this.$getBullets('approachScreenPicture')]
      }

      if (slides.length === 3) {
        const copySlides = JSON.parse(JSON.stringify(slides))
        slides.push(...copySlides)
      }
      slides.forEach((item, index) => {
        item.index = index
        item.isActive = index === 0
        this.sliderProjectsStatus[index] = false
      })
      return slides || []
    },
  },
  mounted() {
    this.windowSizeHandler()
    window.addEventListener('resize', this.windowSizeHandler, { passive: true })
    this.sliderOptions.slideChanged = (slider) => {
      this.currentSlide = slider.details().relativeSlide
      this.slides.forEach((item, index) => {
        if (this.isVideoSlide(item.url)) {
          if (index !== this.currentSlide) {
            item.isActive = false
            this.$refs[`slide${index}`].pauseVideo()
          } else {
            item.isActive = true
            if (!this.isFirstSliderInit) {
              this.$refs[`slide${index}`].startVideo()
            }
          }
        }
      })
    }
    if (this.slides.length && this.$refs.slider) {
      this.$refs.slider.slider.refresh(this.sliderOptions)
    }
    setTimeout(() => (this.isFirstSliderInit = false), 200)
  },
  methods: {
    windowSizeHandler() {
      this.isMobile = window.innerWidth <= DESKTOP_MIN_WIDTH
    },
    showIcon(routes) {
      return routes.includes(this.$route.path.split('/').pop())
    },
    fixProjectPicture(projectPicUrl) {
      const url = this.projectPicture(projectPicUrl)
      return 'background-image: url("' + url + '")'
    },
    startVideo() {
      this.isVideoActive = true
    },
    projectPicture(url) {
      if (url) {
        return url
      }

      return require('@/assets/img/redesign/pc/how-slide-01.png')
    },
    isVideoSlide(url) {
      return url.includes('mp4')
    },
    toggleProjectDescription(index) {
      let indexDouble = null
      if (this.initialSlidesCount === 3) {
        indexDouble =
          (index + this.initialSlidesCount) % (this.initialSlidesCount * 2)
        if (index > indexDouble) {
          ;[index, indexDouble] = [indexDouble, index]
        }
      }
      this.sliderProjectsStatus[index] = !this.sliderProjectsStatus[index]
      if (this.initialSlidesCount === 3 && indexDouble !== null) {
        this.sliderProjectsStatus[indexDouble] =
          !this.sliderProjectsStatus[indexDouble]
      }

      if (this.slides.length && this.$refs.slider) {
        this.$refs.slider.$forceUpdate()
      }
    },
  },
}
